import React from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';

const DropDownFilter = ({ options, defaultText, value, onchange, paramkey }) => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const pathname = location.pathname;

    const handleSearch = (term) => {
        const params = new URLSearchParams(searchParams);
        if (term) {
            params.set(`${paramkey}`, term);
        }
        else
            params.delete(`${paramkey}`);
        navigate(`${pathname}?${params.toString()}`);
    };

    const handleChange = (e) => {
        const value = e.target.value;

        if (onchange)
            onchange(e);

        handleSearch(value);
    };

    return (
        <select onChange={handleChange} value={value || ""} className="block w-full h-[40px] px-2  bg-thirdly border border-gray-500/100 text-white rounded-md " defaultValue="">
            <option value="" disabled className='text-white'>{defaultText}</option>
            {options?.map((option, index) => (
                <option className='text-whtie' key={index} value={option?.id}>
                    {option?.name}
                </option>
            ))}
        </select>
    );
};

export default DropDownFilter;